import React from 'react'
import './Templates.scss'
import { Link } from 'react-router-dom'

const nav = props =>
<Link to={props.href}>
   {props.title}
</Link>

export default nav